import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteRolepermissionsFromAPI, fetchRolepermissionsFromAPI } from "../../../services/RolepermissionService";


export const fetchRolepermissions = createAsyncThunk(
  "rolepermissions/fetchRolepermissions",
  async ({ page, perPage, search }, { rejectWithValue }) => {
    try {
      const response = await fetchRolepermissionsFromAPI(page, perPage, search);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteRolepermission = createAsyncThunk(
  "rolepermissions/deleteRolepermission",
  async (rolepermissionId, { rejectWithValue }) => {
    try {
      const response = await deleteRolepermissionsFromAPI(rolepermissionId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);



const rolepermissionSlice = createSlice({
  name: "rolepermissions",
  initialState: {
    rolepermissions: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    rolepermissionSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:""
  },
  reducers: {
    setSearchRolepermission: (state, action) => {
      state.rolepermissionSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRolepermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRolepermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.rolepermissions = action.payload.data;
        state.currentPage = action.payload.meta.current_page;
        state.lastPage = action.payload.meta.last_page;
        state.perPage = action.payload.meta.per_page;
        state.firstItem = action.payload.meta.from; // ✅ Ambil `from` dari API
        state.totalCount = action.payload.meta.total;
      })
      .addCase(fetchRolepermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteRolepermission.fulfilled, (state, action) => {
        state.rolepermissions = state.rolepermissions.filter(rolepermission => rolepermission.id !== action.payload);
      })
      .addCase(deleteRolepermission.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchRolepermission, setPage, setVisibilityFilter, setPerPage, setKeywordSearch } = rolepermissionSlice.actions;
export default rolepermissionSlice.reducer;
